<template>
  <v-navigation-drawer
    :value="isPopUpDialogConfigOpen"
    :permanent="isPopUpDialogConfigOpen"
    width="800px"
    max-width="100vw"
    right
    fixed
    temporary
    color="grey lighten-3"
    style="z-index: 11; transition: 0.5s cubic-bezier(0.4, 0, 0.2, 1)"
  >
    <v-card min-height="100vh" color="grey lighten-3">
      <BaseToolbar
        button-save
        @close="close"
        @save="submitData"
        title="Pop Up de nuevo lanzamiento"
        type-title="icon"
        icon="edit"
        :loader-save="submitLoading"
        buttonSave
      />
      <v-progress-linear v-if="loading" indeterminate height="5" class="my-0" />
      <v-card-text v-else style="overflow-y: auto; height: calc(100vh - 64px)">
        <v-container class="pa-5">
          <v-row justify="center">
            <v-col cols="12" sm="10">
              <v-switch
                v-model="payload.status"
                inset
                color="primary"
                true-value="enabled"
                false-value="disabled"
                label="Activar popup de nuevo lanzamiento"
              />
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col cols="12" sm="10">
              <v-card>
                <v-card-title class="pa-4 justify-space-between">
                  <span class="title primary--text">Traducciones</span>
                  <v-btn
                    color="primary"
                    icon
                    @click="openTranslationDialog(null)"
                  >
                    <v-icon>add</v-icon>
                  </v-btn>
                </v-card-title>
                <v-divider />
                <v-list v-if="payload.translations.length">
                  <v-list-item
                    v-for="(item, index) in payload.translations"
                    :key="item.language_code"
                  >
                    <v-list-item-action>
                      <v-checkbox
                        v-model="item.is_default"
                        size="xl"
                        style="height: 24px; width: 24px"
                        hide-details
                        class="pa-0 ma-0"
                        :readonly="item.is_default"
                        @change="setDeafultTranslation(index)"
                      ></v-checkbox>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>{{ item.title }}</v-list-item-title>
                      <v-list-item-subtitle>{{
                        getLanguage(item.language_code).name
                      }}</v-list-item-subtitle>
                    </v-list-item-content>

                    <v-list-item-action class="d-flex flex-row">
                      <v-btn
                        color="error"
                        icon
                        :disabled="item.is_default"
                        @click="removeTranslation(index)"
                      >
                        <v-icon>delete</v-icon>
                      </v-btn>
                      <v-btn
                        color="primary"
                        icon
                        @click="openTranslationDialog(index)"
                      >
                        <v-icon>tune</v-icon>
                      </v-btn>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
                <v-card-text v-else class="pa-4">
                  <div class="text-center my-8">
                    <v-img
                      :src="require('@/assets/svg/box_empty.svg')"
                      height="150"
                      max-height="150px"
                      aspect-ratio="1"
                      contain
                    />
                    <div class="grey--text subtitle-1">
                      {{ $t("common.no_results_found") }}
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12" sm="10">
              <v-select
                v-model="selectedOrganizations"
                :items="organizationNames"
                label="Selecciona las organizaciones"
                chips
                outlined
                multiple
              >
                <template v-slot:prepend-item>
                  <v-list-item ripple @mousedown.prevent @click="toggle">
                    <v-list-item-action>
                      <v-icon>
                        {{ selectIcon }}
                      </v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title> Select All </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="mt-2"></v-divider>
                </template>
              </v-select>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
    <v-dialog
      v-model="isOpenDialogConfig"
      persistent
      :overlay="true"
      max-width="600px"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title class="pa-6">
          Configurar popup de nuevos lanzamientos
        </v-card-title>
        <v-card-text class="pa-8">
          <v-form data-vv-scope="formTranslation">
            <v-row>
              <v-col cols="12">
                <v-select
                  v-model="messageTranslation.language_code"
                  v-validate="'required'"
                  :items="avaliableLanguages"
                  item-text="name"
                  item-value="code"
                  :error-messages="
                    errors.collect(
                      `formTranslation.${$t('profile.profile.language')}`
                    )
                  "
                  :label="$t('profile.profile.language')"
                  :data-vv-name="`formTranslation.${$t(
                    'profile.profile.language'
                  )}`"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="messageTranslation.title"
                  label="Título"
                  v-validate="'required'"
                  data-vv-name="Título"
                  :error-messages="errors.collect('formTranslation.Título')"
                />
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="messageTranslation.content"
                  label="Contenido"
                  v-validate="'required'"
                  data-vv-name="Contenido"
                  :error-messages="errors.collect('formTranslation.Contenido')"
                  no-resize
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="messageTranslation.link"
                  label="Enlace de redireccion"
                  hint="Ejemplo: https://my.afrus.app/new-release"
                  v-validate="'required'"
                  data-vv-name="link"
                  :error-messages="errors.collect('formTranslation.link')"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="messageTranslation.redirect_text"
                  label="Texto del botón de redireccón"
                  v-validate="'required'"
                  data-vv-name="redirect_text"
                  :error-messages="
                    errors.collect('formTranslation.redirect_text')
                  "
                />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions class="pa-4">
          <v-spacer />
          <v-btn
            color="primary"
            text
            width="100px"
            @click="toggleTranslation(false)"
          >
            {{ $t("actions.cancel") }}
          </v-btn>
          <v-btn color="primary" width="100px" @click="saveTranslation()">
            {{ $t("actions.save") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-navigation-drawer>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import BaseToolbar from "@/components/BaseToolbar.vue";
import { organizationService } from "@/services/organization.service";

export default {
  name: "NewReleasePopUpConfig",
  components: {
    BaseToolbar,
  },
  data() {
    return {
      loading: false,
      submitLoading: false,
      isOpenDialogConfig: false,
      indexTranslationSelected: null,
      organizations: [],
      organizationNames: [],
      selectedOrganizations: [],
      payload: {
        status: "disabled",
        organizations: [],
        translations: [],
      },
      messageTranslation: {
        is_default: false,
        language_code: null,
        title: null,
        content: null,
        link: null,
        redirect_text: null,
      },
    };
  },
  watch: {
    async isPopUpDialogConfigOpen(newVal) {
      if (newVal) {
        this.loading = true;
        await this.getDataFromServer();
        this.loading = false;
      }
    },
  },
  computed: {
    ...mapState({
      languages: ({ auth: { locales } }) => locales,
    }),
    ...mapGetters({
      isPopUpDialogConfigOpen: "newReleasePopup/isPopUpDialogConfigOpen",
    }),
    avaliableLanguages() {
      return this.languages.map((e) => {
        return {
          ...e,
          disabled: this.payload.translations.some(
            (item) => item.language_code.toLowerCase() === e.code.toLowerCase()
          ),
        };
      });
    },
    allOrg() {
      return this.selectedOrganizations.length === this.organizations.length;
    },
    someOrg() {
      return this.selectedOrganizations.length > 0 && !this.allOrg;
    },
    selectIcon() {
      if (this.allOrg) return "close";
      if (this.someOrg) return "add";
      return "add";
    },
  },
  async created() {
    this.getAllOrganizations();
  },
  methods: {
    ...mapActions({
      togglePopUpDialogConfig: "newReleasePopup/togglePopUpDialogConfig",
    }),
    getLanguage(code) {
      return this.languages.find((e) => e.code === code);
    },
    close() {
      this.togglePopUpDialogConfig(false);
      this.cleanData();
    },
    async getDataFromServer() {
      try {
        const {
          status = "disabled",
          translations = [],
          organizations = [],
        } = (await organizationService.getNewReleasePopupConfig()).data;

        // this.organizations = organizations
        this.selectedOrganizations = organizations.map((org) => org.name);
        this.payload = {
          status,
          organizations,
          translations,
        };
      } catch (error) {
        console.log(error);
      }
    },
    async submitData() {
      if (this.payload.translations.length === 0) {
        this.$noty.error("Debe agregar al menos una traducción");
        return;
      }
      this.submitLoading = true;
      try {
        let orgs = [];
        for (let i = 0; i < this.organizations.length; i++) {
          for (let j = 0; j < this.selectedOrganizations.length; j++) {
            if (this.organizations[i].name === this.selectedOrganizations[j]) {
              orgs.push(this.organizations[i]);
            }
          }
        }
        this.payload.organizations = orgs;
        await organizationService.updateNewReleasePopupConfig(this.payload);
        this.close();
        this.$noty.success("Configración actualizada");
      } catch (error) {
        console.log(error);
        this.$noty.error("Error al actualizar");
      } finally {
        this.submitLoading = false;
      }
    },
    async toggleTranslation(display = false) {
      this.isOpenDialogConfig = display;
      this.$validator.reset();
    },
    cleanData() {
      this.loading = false;
      this.submitLoading = false;
      this.payload = {
        status: "disabled",
        organizations: [],
        selectedOrganizations: [],
        organizationNames: [],
        translations: [],
      };
      this.messageTranslation = {
        is_default: false,
        language_code: null,
        title: null,
        content: null,
        link: null,
      };
      this.$validator.reset();
    },
    setDeafultTranslation(index) {
      this.payload.translations.forEach((item) => {
        item.is_default = false;
      });
      this.payload.translations[index].is_default = true;
    },

    openTranslationDialog(index = null) {
      this.indexTranslationSelected = index;
      if (index != null) {
        this.messageTranslation = this.payload.translations[index];
      } else {
        this.messageTranslation = {
          is_default: false,
          language_code: null,
          title: null,
          content: null,
          link: null,
        };
      }
      this.toggleTranslation(true);
    },
    async saveTranslation() {
      const isValid = await this.$validator.validateAll("formTranslation");
      if (!isValid) {
        return;
      }
      if (this.indexTranslationSelected != null) {
        this.payload.translations[this.indexTranslationSelected] =
          this.messageTranslation;
      } else {
        this.payload.translations.push(this.messageTranslation);
        if (this.payload.translations.length === 1) {
          this.payload.translations[0].is_default = true;
        }
      }
      this.toggleTranslation(false);
    },
    removeTranslation(index) {
      this.payload.translations.splice(index, 1);
    },
    toggle() {
      this.$nextTick(() => {
        if (this.allOrg) {
          this.selectedOrganizations = [];
        } else {
          this.selectedOrganizations = this.organizationNames.slice();
        }
      });
    },
    async getAllOrganizations() {
      try {
        const response = await organizationService.getAllOrganizations();

        const data = response.data;
        this.organizationNames = data.map((org) => {
          return org.name;
        });
        this.organizations = response.data;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
